<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`core.payment.status.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function () {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'new': {
            return 'blue';
          }
          case 'pending': {
            return 'fresh';
          }
          case 'success': {
            return 'green';
          }
          case 'failed': {
            return 'error';
          }
          case 'failed_mc': {
            return 'error';
          }
          case 'frozen': {
            return 'light-blue';
          }

          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
